import { useMutation } from 'react-query';
import {
  createWhatsAppNumberAsync,
  deleteWhatsAppNumberAsync,
  getWhatsAppNumberByIdAsync,
  updateWhatsAppNumberAsync,
} from '../../index';

export const useCreateWhatsAppNumber = () =>
  useMutation(createWhatsAppNumberAsync);

export const useUpdateWhatsAppNumber = () =>
  useMutation(updateWhatsAppNumberAsync);

export const useDeleteWhatsAppNumber = () =>
  useMutation(deleteWhatsAppNumberAsync);

export const useGetWhatsAppNumber = () =>
  useMutation(getWhatsAppNumberByIdAsync);
